import { Injectable } from '@angular/core';
import {AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument} from 'angularfire2/firestore';
import {Batteries,BatteriesData} from '../pages/layout/list-batteries/list-batteries.component';
import { map, filter, catchError, mergeMap } from 'rxjs/operators';
import 'rxjs/add/operator/map';
import { environment } from '../../environments/environment';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { API_ENDPOINTS } from './api-endpoints';

@Injectable({
  providedIn: 'root'
})
export class BatteriesService {

  orgUrl = "";

  constructor(private afs: AngularFirestore) {}


  getAssignBatteryState(data){
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'patch',
        url: `${API_ENDPOINTS.battery.changeBatteryStatus}`,
        headers: { 
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*'
        },
        data : data
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getAllBatteriesData(offset = 0, limit=100000) {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.battery.getAllBatteriesData}?offset=${offset}&limit=${limit}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async getListOfBatteries() {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.battery.getListOfBatteries}?offset=${0}&limit=${10000}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  async searchBatteryByBatteryId(search) {
    return await new Promise((resolve, reject) => {
      axios.request({
        method: 'get',
        url: `${API_ENDPOINTS.battery.searchBatteryByBatteryId}/${search.trim()}`,
      })
        .then((response: AxiosResponse) => {
          resolve(response);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  }

  getBatteries(){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }
  
  
  getUnoccupiedBatteries(){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection, ref =>
    ref.where('User', '==',"")).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });

  }

  getBatteriesByUser(username){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection,ref =>
    ref.where('User', '==',username)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });

  }

  getBatteryByIMEI(imei) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection<Batteries>(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection,ref =>
    ref.where('IMEI', '==',imei)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getBatteriesData(uid){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection+'/'+uid).snapshotChanges().pipe(map(action => {
        const data = action.payload.data() as Batteries;
        const id = action.payload.id;
        return { id, ...data };
    })
    );
  }

  getBatteriesSummaryData(uid){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection('Scooters',ref =>
    ref.where('BatteryID', '==',uid)).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as BatteriesData;
        const id = action.payload.doc.id;
        return { id, ...data };
    });
  });;
  } 

  addBatteries(data){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) => {
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection).add(data).then(res => {
        this.editBattery({id: res.id, ...data}, res.id).then(result => {
          resolve(res);
        });
      }, err => reject(err));
    });
  }

  editBattery(data,id){
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection).doc(id).update(data).then(res => {
        resolve(res);
      }, err => reject(err));
  });
  
  }

  deleteBattery(battery) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection).doc(battery.id).delete();
}

  addbatteriesType(data) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return new Promise<any>((resolve, reject) =>{
      this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesTypeCollection).add(data).then(res => {
        resolve(res)
        return new Promise<any>((resolve, reject) => {
          let updatedData = {id:res.id, ...data}
          this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesTypeCollection).doc(res.id).update(updatedData).then(res => {resolve(res)}, err => reject(err));
        });
      }, err => reject(err));
  });
  }

  getBatteriesType() {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesTypeCollection).snapshotChanges().map(actions => {
      return actions.map(action => {
        const data = action.payload.doc.data() as Batteries;
        const id = action.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  getBatteryType(uid) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    return this.afs.doc(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesTypeCollection+'/'+uid).snapshotChanges().pipe(map(action => {
      const data = action.payload.data();
      const id = action.payload.id;
      return { id, ...data };
  })
  );
  }

  UpdateBatteryStatus(id,data) {
    this.orgUrl = localStorage.getItem('currentOrganisation');
    this.afs.collection(environment.env.EnvBaseUrl+'/'+this.orgUrl+'/'+environment.env.BatteriesCollection).doc(id).update({'Status': data});
  }

}
